import styled from 'styled-components';

import { ThemeProps } from '@core/type';

import { Typography } from './Typography';
import { TypographyProps } from './interface-typography';

export const TableHeadingText = styled(Typography)<TypographyProps>(
  ({
    theme: {
      typography: {
        table: { heading },
      },
    },
    ...restProps
  }: {
    theme: ThemeProps;
  }) => ({
    ...heading,
    ...restProps,
  }),
);
